// extracted by mini-css-extract-plugin
export default {"majorContainer":"course_majorContainer__GRZl-","container":"course_container__uKFrI","heading":"course_heading__I+bjW"};